import { render, staticRenderFns } from "./QuestionnaireActiveButton.vue?vue&type=template&id=ec86cea6&"
import script from "./QuestionnaireActiveButton.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireActiveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports